module.exports = __webpack_public_path__ + "0f2b7623ca36534f8f4fc7792c1361d7.svg";